import type { IJobInformation } from '../JobInformation';

export const getReferenceBalance = (
  referenceCheckBalance: IJobInformation['referenceCheckBalance'],
): number | null => {
  if (!referenceCheckBalance || referenceCheckBalance.expired) {
    return null;
  }

  return referenceCheckBalance.availableBalance;
};
